import { React, useState, useEffect } from 'react';
import customIconPath from '../../assets/calIcon.svg';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  AppBar,
  Toolbar,
  Typography,
  Container,
  Grid,
  CardMedia,
  CardContent,
  Card,
  Paper
} from '@mui/material';

const cards = [1];

const Tools = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    handleResize();

    window.addEventListener('resize', handleResize);


    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <Grid Container xs={12} marginRight={isMobile ? 2 : 24}>
      <Box className="toolContainer" >

        <Typography variant="h2" gutterBottom sx={{ fontSize: isMobile ? '32px' : '24px', fontWeight: 700, fontFamily: 'Inter' }}>
          Tools
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '18px', marginBottom: 2, fontFamily: 'DM Sans', fontWeight: 400, lineHeight: '24px', textAlign: 'justify' }}>
          Calculate Your Home Future-Empowering Your Choices.
        </Typography>

        <Grid container className="calContainer" spacing={4} >
          {cards.map((card) => (
            <Grid item key={card} xs={12} sm={6} md={4} xl={6}>
              <Card className="card" style={{ width: 'auto', height: 'auto', }}>
                <CardContent className="CardContent" sx={{ backgroundColor: '#F8FBFC' }}>
                  {/* <Grid container direction="row" alignItems="center" spacing={2}>
                  <Grid item>
                    <img className="imgCal" src={customIconPath} alt="Custom Icon" style={{ marginRight: '0.5rem' }} />
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}>

                  <Link to={`/support/mortgage-cal-type/${card}`} className="guide-link" key={card}>
                  <Typography variant="h5" sx={{ fontSize: '24px' , paddingBottom:2.5,paddingTop:2.5, fontWeight:700, fontFamily:'Inter'}}>
                      Mortgage Calculator Tool
                    </Typography>
                    </Link>
                  </Grid>
                </Grid> */}
                  <Grid container alignItems="center" spacing={2} margin="auto">
                    <Grid item xs={2}>
                      <img className="imgCal" src={customIconPath} alt="Custom Icon" style={{ width: '100%', height: 'auto' }} />
                    </Grid>
                    <Grid item xs={10}>
                      <Link to={`/support/mortgage-cal-type/${card}`} className="guide-link" key={card} style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
                        <Typography variant="h2" style={{ fontSize: '20px', fontWeight: 700, fontFamily: 'Inter' }}>
                          Mortgage Calculator Tool
                        </Typography>
                      </Link>
                    </Grid>
                  </Grid>

                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
};

export default Tools;
